import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["pos"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as Yup from 'yup';
import { parsePhoneNumberFromString, ParseError } from 'libphonenumber-js';
export function mergeFormFields(baseFields, extraFields, t) {
  if (baseFields === void 0) {
    baseFields = [];
  }
  if (extraFields === void 0) {
    extraFields = [];
  }
  var normalize = function normalize(arr) {
    return arr.reduce(function (acc, el) {
      var _objectSpread2;
      return _objectSpread(_objectSpread({}, acc), {}, (_objectSpread2 = {}, _objectSpread2[el.slug] = el, _objectSpread2));
    }, {});
  };
  var base = normalize(baseFields);
  var extra = normalize(extraFields);
  var fields = _objectSpread(_objectSpread({}, extra), base);
  return Object.values(fields).map(function (el, pos) {
    return _objectSpread(_objectSpread({}, el), {}, {
      isRequired: extra[el.slug] ? extra[el.slug].isRequired : el.isRequired,
      pos: base[el.slug] && typeof base[el.slug].pos === 'number' ? base[el.slug].pos : 9 + pos
    });
  }).sort(function (prev, next) {
    return prev.pos > next.pos ? 1 : -1;
  }).map(function (_ref) {
    var pos = _ref.pos,
      el = _objectWithoutPropertiesLoose(_ref, _excluded);
    return _objectSpread(_objectSpread({}, el), {}, {
      name: t(el.slug) === el.slug ? el.name : t(el.slug)
    });
  });
}
export function getFormState(_ref2) {
  var initialValues = _ref2.initialValues,
    buyerFields = _ref2.buyerFields,
    holderFields = _ref2.holderFields,
    _ref2$attendesForPurc = _ref2.attendesForPurchase,
    attendesForPurchase = _ref2$attendesForPurc === void 0 ? 1 : _ref2$attendesForPurc,
    participants = _ref2.participants;
  function createState(fields, prefix, initials) {
    if (fields === void 0) {
      fields = [];
    }
    if (prefix === void 0) {
      prefix = '';
    }
    if (initials === void 0) {
      initials = {};
    }
    return fields.reduce(function (acc, el) {
      var _objectSpread3;
      return _objectSpread(_objectSpread({}, acc), {}, (_objectSpread3 = {}, _objectSpread3[prefix + el.slug] = initials[el.slug] || '', _objectSpread3));
    }, {});
  }
  var initialState = createState(buyerFields, '', initialValues);
  initialState.emailConfirm = initialState.email;
  var extraState = Array(attendesForPurchase).fill().reduce(function (ticketHolders, el, i) {
    return _objectSpread(_objectSpread({}, ticketHolders), createState(holderFields, i + 1 + "_"));
  }, {});
  if (participants) Object.keys(participants).forEach(function (participantKey) {
    if (/\d/.test(participantKey) && !(participantKey in extraState)) delete participants[participantKey];
  });
  return _objectSpread(_objectSpread(_objectSpread({}, initialState), extraState), participants);
}
var YUP_PHONE_METHOD = 'phone';
Yup.addMethod(Yup.string, YUP_PHONE_METHOD, function yupPhone(errorMsg) {
  return this.test(YUP_PHONE_METHOD, errorMsg.noValid, function (value) {
    if (!value) return true;
    if (!value.includes('+')) {
      return this.createError({
        message: errorMsg.noPrefix
      });
    }
    try {
      var phoneNumber = parsePhoneNumberFromString(value);
      return phoneNumber ? phoneNumber.isValid() : false;
    } catch (error) {
      if (error instanceof ParseError) {}
      return false;
    }
  });
});
var YUP_BIRTH_METHOD = 'birth';
Yup.addMethod(Yup.string, YUP_BIRTH_METHOD, function yupBirth(errorMsg) {
  return this.test(YUP_BIRTH_METHOD, errorMsg.noValid, function (value) {
    if (Date.parse(value) > Date.now()) {
      return this.createError(errorMsg);
    }
    return true;
  });
});
export function makeValidationSchema(fields, trans) {
  var phoneErrorsMsg = {
    noValid: trans('phoneError'),
    noPrefix: trans('phonePrefixError')
  };
  var birthErrorMessage = trans('birthdateMaxError');
  var emailErrorMessage = trans('phoneErrorWhitespace');
  var extraFieldsSchema = Object.keys(fields).reduce(function (list, field) {
    if (field.includes('phone')) {
      list[field] = Yup.string().phone(phoneErrorsMsg).required();
    } else if (field.includes('birth')) {
      list[field] = Yup.string().birth(birthErrorMessage).required();
    } else if (field.includes('email')) {
      list[field] = Yup.string().email(emailErrorMessage).required();
    } else {
      list[field] = Yup.string().required();
    }
    return list;
  }, {});
  var defaultSchema = {
    firstName: Yup.string().required(),
    lastName: Yup.string().required(),
    email: Yup.string().email().lowercase().required().test('email', trans('phoneErrorWhitespace'), function (value, context) {
      return value ? !value.includes(' ') : true;
    }),
    emailConfirm: Yup.string().email().lowercase().oneOf([Yup.ref('email'), null]).required().test('emailConfirm', trans('phoneErrorWhitespace'), function (value, context) {
      return value ? !value.includes(' ') : true;
    }),
    phone: Yup.string().phone(phoneErrorsMsg).required(function () {
      return fields.phone;
    })
  };
  return Yup.object().shape(_objectSpread(_objectSpread({}, extraFieldsSchema), defaultSchema));
}
export function convertBookingData(values) {
  var bookingFields = {};
  var _extractParticipantDe = extractParticipantDetails(values),
    buyer = _extractParticipantDe.buyer,
    holders = _extractParticipantDe.holders;
  bookingFields.bookingFormFields = formToArray(buyer);
  var holderValues = Object.values(holders);
  if (holderValues.length) {
    bookingFields.ticketHolderFormFields = holderValues.map(formToArray);
  }
  return bookingFields;
}
function extractParticipantDetails(values) {
  return Object.keys(values).reduce(function (lists, slug) {
    if (!slug.includes('_')) {
      lists.buyer[slug] = values[slug];
    } else {
      var _slug$split = slug.split('_'),
        id = _slug$split[0],
        holderField = _slug$split[1];
      if (!lists.holders[id]) lists.holders[id] = {};
      lists.holders[id][holderField] = values[slug];
    }
    return lists;
  }, {
    buyer: {},
    holders: {}
  });
}
function formToArray(form) {
  return Object.keys(form).filter(function (slug) {
    return form[slug];
  }).map(function (slug) {
    if (slug === 'phone') {
      return {
        name: slug,
        value: form[slug].replace(/ /g, '')
      };
    }
    if (slug.toLowerCase().includes('name')) {
      return {
        name: slug,
        value: form[slug].trim()
      };
    }
    return {
      name: slug,
      value: form[slug]
    };
  });
}